import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Notification} from "../../_types/notification";
import {NavigationEnd, Router} from "@angular/router";
import {NotificationService} from "../../_services/notification.service";
import {LocalStorageService} from "../../_services/local-storage.service";
import {combineLatest, debounceTime, filter, Observable, switchMap, take} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {Community} from "../../_types/communities";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {CommunitiesService} from "../../_services/communities.service";

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrl: './notifications-list.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationsListComponent {
    notifications: Notification[] = [];
    loading: boolean = true;

    constructor(
        private readonly router: Router,
        private readonly notificationService: NotificationService,
        private readonly communitiesService: CommunitiesService,
        private readonly localStorageService: LocalStorageService,
        public dialog: MatDialog,
        private readonly matDialog: MatDialogRef<NotificationsListComponent>,
    ) {
        this.notificationService.getNotifications().subscribe(r => {
            this.notifications = r;
        })
        const community$: Observable<Community | null> = this.communitiesService.getCurrentDashboardCommunity();
        const router$: Observable<NavigationEnd> = this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        combineLatest([community$, router$])
            .pipe(
                debounceTime(200),
                switchMap((): Observable<Notification[]> => this.notificationService.getNotifications()),
                takeUntilDestroyed()
            )
            .subscribe(res => {
                this.loading = false;
                this.notifications = res;
            }, error => {
                this.loading = false;
                console.error(error);
            });
    }

    get selectedCommunity(): Community | null {
        return this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
    }

    markNotificationAsRead(notification: Notification): void {
        this.notificationService.markNotificationAsRead(notification.id).pipe(take(1))
            .subscribe((): void => {
                notification.is_read = true;
            });
    }

    trackByNotificationId(index: number, notification: any): number {
        return notification.id;
    }

    notificationRedirect(notification: Notification): void {
        this.notificationService.notificationRedirect(notification)
    }

}
